import { XMarkIcon } from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';
import { selectSchema } from '../../store/selectors';
import { getProperty, isCWTSchemaField, isCWTSchemaSection, isCWTSchemaTable } from '../../store/utils';
import FieldIcon from '../../../../components/custom-worksheet/FieldIcon';
import PropertyName from '../components/PropertyName';
import Appearance from './Appearance';
import Configurations from './Configurations';
import Reconciliation from './reconciliation/Reconciliation';

type SidePanelContainerProps = {
    propertyId?: string;
    onClose: () => void;
};

function SidePanelContainer({ propertyId, onClose }: SidePanelContainerProps): JSX.Element {
    const schema = useSelector(selectSchema);
    const property = getProperty(schema, propertyId || '');

    if (property === null || (!isCWTSchemaField(property) && !isCWTSchemaTable(property) && !isCWTSchemaSection(property))) {
        return <></>;
    }

    return (
        <div>
            <div className="flex items-center justify-between py-1 border-b border-gray-300">
                <div className="flex items-center gap-1 pl-1">
                    {isCWTSchemaField(property) && (
                        <div className="w-4 h-4 text-gray-500 shrink-0 m-1">
                            <FieldIcon type={property.type} />
                        </div>
                    )}
                    <div className="w-[200px]">
                        <PropertyName fieldName={property.name} id={property.id} />
                    </div>
                </div>
                <XMarkIcon className="w-4 h-4 text-gray-500 m-1 cursor-pointer" onClick={onClose} />
            </div>
            <Configurations property={property} />
            {isCWTSchemaField(property) && (
                <Appearance property={property} tableRowStyles={'styles' in property ? property.styles : undefined} />
            )}
            {isCWTSchemaField(property) && <Reconciliation property={property} schema={schema} />}
        </div>
    );
}

export default SidePanelContainer;
